import React from 'react';
import { useLanguage } from './LanguageContext';
import './ConfirmModal.css';

export const ConfirmModal = ({ open, title, message, confirmLabel, cancelLabel, onConfirm, onCancel, variant = 'primary' }) => {
  const { tt } = useLanguage();

  if (!open) return null;

  return (
    <div className="confirm-modal-overlay" onClick={onCancel} role="dialog" aria-modal="true" aria-labelledby="confirm-modal-title">
      <div className="confirm-modal-glass" onClick={(e) => e.stopPropagation()}>
        <h3 id="confirm-modal-title" className="confirm-modal-title">{title}</h3>
        <p className="confirm-modal-message">{message}</p>
        <div className="confirm-modal-actions">
          <button type="button" className="confirm-modal-btn cancel" onClick={onCancel}>
            {cancelLabel || tt('Cancel')}
          </button>
          <button type="button" className={`confirm-modal-btn ${variant}`} onClick={onConfirm}>
            {confirmLabel || tt('Confirm')}
          </button>
        </div>
      </div>
    </div>
  );
};
